module.exports = "<div chart-container class=\"{{:: $styles['chart-component'] }}\"></div>\n";